import * as React from 'react';

import { DatosEmergencia } from '../tipos';
import Campo from './Campo';
import CorreosYTelefonos from './CorreosYTelefonos';
import Info from './Info';

type InformacionDeContactoProps = DatosEmergencia;
const InformacionDeContacto: React.FunctionComponent<InformacionDeContactoProps> = props => {
    const { nombreCompleto, correos, telefonos, relacionConAlumno } = props;
    return (
        <Info titulo={'Contacto de emergencia'}>
            <Campo etiqueta='Nombre' valor={nombreCompleto} />
            <CorreosYTelefonos correos={correos} telefonos={telefonos} />
            <Campo etiqueta='Relación con alumno' valor={relacionConAlumno} />
        </Info>
    );
};

export default InformacionDeContacto;



// WEBPACK FOOTER //
// ./src/modulos/Alumnos/paginas/FichaDeAlumno/paginas/InformacionGeneral/componentes/InformacionDeContacto.tsx